import React, {useCallback, useMemo} from 'react';
import {useDispatch, useSelector} from 'react-redux';

import {CopyButton} from 'src/components/copy-button';
import {Skeleton, SkeletonItem} from 'src/components/skeleton';

import {EllipsisTextHint} from '@pb/kit-component-ellipsis-text-hint';
import {Group} from '@pb/kit-component-group';
import {Icons} from '@pb/kit-component-icon';
import {BasicIconButton} from '@pb/kit-component-icon-button';


import {back, selectDrawerDetails} from '../entitlement-drawer.slice';
import {EntitlementType as EntitlementTypes} from '../typedef';

export const DrawerHeader = () => {
    const dispatch = useDispatch();

    const {
        history,
        resourceDetails,
        grantDetails,
        presetDetails,
        roleDetails,
    } = useSelector(selectDrawerDetails);

    const currentEntitlement = useMemo(
        () => (history.length ? history[history.length - 1] : null),
        [history],
    );

    const header = useMemo(() => {
        if (!currentEntitlement) {
            return '';
        }
        const {entitlementType} = currentEntitlement;
        switch (entitlementType) {
            case EntitlementTypes.RESOURCE:
                return resourceDetails?.data?.name || '';
            case EntitlementTypes.GRANT:
                return grantDetails?.data?.name || '';
            case EntitlementTypes.ROLE:
                return roleDetails?.data?.name || '';
            case EntitlementTypes.PRESET:
                return presetDetails?.data?.name || '';
            case EntitlementTypes.NOT_ASSOCIATED:
                return 'Delete Entitlements';
            default:
                return '';
        }
    }, [currentEntitlement, grantDetails, roleDetails, resourceDetails, presetDetails]);

    const entityName = useMemo(() => {
        if (!currentEntitlement) {
            return '';
        }
        const {entitlementType} = currentEntitlement;
        switch (entitlementType) {
            case EntitlementTypes.RESOURCE:
                return 'Resource name';
            case EntitlementTypes.GRANT:
                return 'Grant name';
            case EntitlementTypes.ROLE:
                return 'Role name';
            case EntitlementTypes.PRESET:
                return 'Preset name';
            default:
                return '';
        }
    }, [currentEntitlement]);

    const goToPreviousEntitlement = useCallback(() => {
        dispatch(back());
    }, [dispatch]);

    return (
        <Skeleton shown={!header} view={<SkeletonItem width={250} height={28}/>}>
            <Group alignItems="center" style={{width: 330}}>
                {history.length > 1 && (
                    <BasicIconButton
                        onClick={goToPreviousEntitlement}
                        iconProps={{type: Icons.ANGLE_LEFT}}
                    />
                )}
                <div style={{maxWidth: 260}}>
                    <EllipsisTextHint title={header}>{header}</EllipsisTextHint>
                </div>
                {entityName ? (
                    <CopyButton copiedText={header} entityName={entityName}/>
                ) : null}
            </Group>
        </Skeleton>
    );
};
